import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";

export default function LocationSnapshotBulkChangeQuantityModal({
  selectedCount,
  saving,
  onClose,
  onApply,
}) {
  const [quantityInput, setQuantityInput] = useState("");

  const parsedQuantity = Number(quantityInput);
  const isValidQuantity =
    quantityInput !== "" && Number.isInteger(parsedQuantity) && parsedQuantity >= 0;

  const handleApply = () => {
    if (!isValidQuantity || saving) {
      return;
    }

    onApply(parsedQuantity);
  };

  return (
    <Dialog open onClose={() => !saving && onClose()} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography fontSize={22} fontWeight={500} color="text.secondary" align="center">
          Change Quantity
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          disabled={saving}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2.5} py={2}>
          <Typography variant="body2" color="text.secondary" align="center">
            {selectedCount} selected {selectedCount === 1 ? "item" : "items"}
          </Typography>
          <TextField
            type="number"
            fullWidth
            autoFocus
            label="Set quantity for all selected items"
            value={quantityInput}
            onChange={(event) => setQuantityInput(event.target.value)}
            disabled={saving}
            inputProps={{ min: 0, step: 1 }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, justifyContent: "flex-end" }}>
        <Button variant="outlined" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!isValidQuantity || saving}
          onClick={handleApply}
          startIcon={saving ? <CircularProgress size={18} /> : undefined}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}
